<template>
  <b-container>
    <b-row class="upcoming-events-title">
      <b-col>
        <p>UPCOMING EVENTS</p>
      </b-col>
    </b-row>
    <b-row
      v-for="{
        id,
        name,
        banner,
        city,
        start_date,
        end_date,
        award,
        event,
        type,
        awards_venue,
        hotel_details,
        slug
      } in events"
      :key="id"
      class="upcoming-events-container"
      @click="toUpcomingEvents(event, award, slug)"
    >
      <b-col cols="2" class="upcoming-events-img-col">
        <img  :src="banner" class="upcoming-events-img" />
      </b-col>
      <b-col cols="10">
        <p class="upcoming-events-name">{{ name }}</p>
        <p class="upcoming-events-date">
          {{ city }} • {{ eventDays(start_date, end_date) }}
          {{ moment(start_date).format("MMMM") }}
        </p>
        <p class="upcoming-events-venue" v-if="type=='award'">{{awards_venue}}</p>
        <p class="upcoming-events-venue" v-if="type=='event'&& hotel_details">{{hotel_details.name}}</p>
      </b-col>
    </b-row>

    <b-row>
      <router-link
        :to="{ name: 'ccAllEvents' }"
        class="all-events button"
        exact
      >
        <button class="btn-def">All Events</button>
      </router-link>
    </b-row>
  </b-container>
</template>

<script>
import UpcomingEvents from '../../utils/mixins/UpcomingEvents';

export default {
  name: 'UpcomingEvents',
  mixins: [UpcomingEvents],
};
</script>

<style scoped>
.btn-def {
  color: white;
  font-size: 15px;
  text-align: center;
  border: solid 1px #bd9d5f;
  background-color: #bd9d5f;
  width: 100%;
  height: 37px;
  border-radius: 0 0 10px 10px;
}
.upcoming-events-container {
  background-color: white;
  padding: 15px 0 15px 5px;
  margin-bottom: 1px;
  cursor: pointer;
}
.upcoming-events-title {
  background-color: white;
  padding: 13px;
  margin-bottom: 1px;
  border-radius: 0 10px 0 0;
}
.to-booked-event {
  cursor: pointer;
}
.upcoming-events-title p {
  font-family: Montserrat;
  font-size: 18px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.22;
  letter-spacing: normal;
  text-align: center;
  color: #333333;
  margin: 0;
}
.upcoming-events-img-col {
  flex-shrink: 0;
  min-width: 0;
  padding-left: 8px;
  padding-right: 8px;
}
.upcoming-events-img {
  height: 40px;
  width: 40px;
  border-radius: 0 5px 5px 5px;
  flex-shrink: 0;
}
.all-events {
  width: 100%;
}
.upcoming-events-name {
  font-family: Arial;
  font-size: 11px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.23;
  letter-spacing: normal;
  text-align: left;
  color: #707070;
  margin-bottom: 2px;
  overflow: hidden;
  word-break: break-word;
}
.upcoming-events-date, .upcoming-events-venue {
  font-family: Arial;
  font-size: 11px;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.23;
  letter-spacing: normal;
  text-align: left;
  color: #707070;
  margin-bottom: 0px;
  overflow: hidden;
  word-break: break-word;
}
</style>
